<template>
  <div class="c-tabs-content">
    <Spin size="large" fix v-if="!loading" />
    <AutoComplete
      :placeholder="placeholder"
      icon="ios-search"
      clearable
      placement="bottom-start"
      class="c-action-search"
      @on-search="searcHandle"
      @on-change="changeHandle"
    >
      <div class="search-suggest-wrap">
        <div v-for="k in completeData" :key="k.id">
          <span class="suggest-group">“游戏”相关{{ k.name }}</span>
          <li v-for="option in k.children" :value="option.name" :key="option.key" @click="selectHandle(option)">
            <span class="group-title">{{ option.name }}</span>
            <span class="group-count">覆盖{{ option.num }}粉丝</span>
          </li>
        </div>
      </div>
    </AutoComplete>
    <selecter
      v-model="categories"
      :data="data"
      :title="title"
      :transfer="false"
      :disabled="disabled"
      resource-title
      @on-checked="handleCheck"
      @on-title="selectTif"
      @on-select="selectAll"
    />
    <div class="correlation-word">
      <template>
        <dd>
          <a href="javascript:;" @click="selectKeyword(queryWord)"
            ><span>查看{{ queryWord.name }}推荐抖音达人</span></a
          >
        </dd>
      </template>
    </div>
  </div>
</template>
<script>
import { isArray, isEmpty, throttle, getNameOfData, getKeyOfData } from '@/common/js/utils'
import Selecter from '@/components/select/selecter.vue'
export default {
  name: 'Category',
  components: { Selecter },
  props: {
    value: {
      type: Array
    },
    loading: {
      type: Boolean
    },
    data: {
      type: Array
    },
    queryWord: {
      type: Object,
      required: true
    },
    words: {
      type: Array,
      required: true
    },
    completeData: {
      type: Array
    },
    placeholder: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    categories: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    title() {
      const title = '行为类目词'
      let sub = []
      if (isArray(this.resCurrents)) {
        sub = this.resCurrents.map((ret) => {
          const { value } = getKeyOfData(this.data, 'key', ret)
          return value || ''
        })
      }
      return [title, ...sub]
    },
    check() {
      return (id) => this.words.map((ret) => ret.id).includes(id)
    }
  },
  methods: {
    selectHandle(val) {
      if (this.disabled) return
      const { type, name, id } = val
      if (type.toLowerCase() === 'category') this.selectAll({ list: this.data, check: true, current: name, id })
      else this.$emit('on-add', [val])
    },
    changeHandle(val) {
      isEmpty(val) && this.$emit('on-cancel')
    },
    searcHandle(query) {
      throttle(() => {
        this.$emit('on-complete', query)
      }, 1200)()
    },
    handleCheck(val) {
      const { key, check } = val
      if (check && key) this.$emit('on-select', val)
      else this.$emit('on-clear')
    },
    // 选中子集Title
    selectTif(val) {
      this.resCurrents = val
    },
    // 添加相关推荐词
    selectKeyword(word) {
      if (this.disabled || !word.key) return
      this.$emit('on-search', word.key)
    },
    // 全选
    selectAll({ list, check = true, current = '', id }) {
      const setCheck = (meta, val) => {
        if (meta.children && meta.children.length) {
          meta.children.forEach((ret) => {
            setCheck(ret, val)
          })
        }
        this.$set(meta, 'check', val)
        this.$set(meta, '_time', Date.now()) // 用于排序
      }
      // 优先id
      if (id) {
        const item = getKeyOfData(list, 'key', id)
        setCheck(item, check)
      } else if (current) {
        const item = getNameOfData(list, current)
        setCheck(item, check)
      } else {
        // 根层全选
        list.forEach((ret) => {
          setCheck(ret, check)
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.c-tabs-content {
  z-index: 1024;

  .ivu-spin-fix {
    z-index: 998;
  }
}

.correlation-word {
  padding-top: 10px;
  line-height: 20px;
  font-weight: 400;

  dd {
    height: 20px;
    margin: 0;
    overflow: hidden;
  }
}

::v-deep .c-select-item .c-selecter-content {
  height: 263px !important;
}

.search-suggest-wrap {
  background-color: #ffffff;
  overflow-y: auto;
  scrollbar-width: thin;
  -webkit-overflow-scrolling: touch;

  max-height: 240px;

  .suggest-group {
    padding: 0 12px;
    line-height: 24px;
    color: #999;
    font-size: 12px;
  }

  li {
    padding: 0 22px 4px;
    display: flex;
    flex-flow: column;

    &:hover {
      background-color: #f3f3f3;
    }

    .group-title {
      font-size: 14px;
      line-height: 20px;
      color: #555;
    }

    .group-count {
      color: #c3c3c3;
      font-size: 12px;
      line-height: 14px;
    }
  }
}
</style>
